import { isAfter, isBefore, isSameMonth, subMonths, subYears } from 'date-fns'
import { rangeRight } from 'lodash-es'

const now = new Date()

export default class ExtendedDate extends Date {
  private _minDate: Date = new Date('2016-1-1')

  get minDate() {
    return this._minDate
  }

  set minDate(date: Date) {
    this._minDate = date
  }

  private _maxDate?: Date

  get maxDate() {
    return this._maxDate ? this._maxDate : now
  }

  set maxDate(date: Date) {
    this._maxDate = date
  }

  get yearArr() {
    return rangeRight(this.minDate.getFullYear(), this.maxDate.getFullYear() + 1)
  }

  get monthArr() {
    const calcDate = new Date(this.getFullYear(), 0)
    const arr: number[] = []
    for (let i = 1; i <= 12; i++) {
      if (
        (isSameMonth(this.maxDate, calcDate) || isAfter(this.maxDate, calcDate)) &&
        (isSameMonth(this.minDate, calcDate) || isBefore(this.minDate, calcDate))
      ) {
        arr.push(i)
      }
      calcDate.setMonth(i)
    }
    return arr
  }

  get korYearArr() {
    return this.yearArr.map((year) => `${year}년`)
  }

  get korMonthArr() {
    return this.monthArr.map((month) => `${month}월`)
  }

  get prefixMonthArr() {
    return this.monthArr.map((month) => (month < 10 ? `0${month}` : `${month}`))
  }

  get pastTwelveMonthArr() {
    return Array.from({ length: 12 }, (v, i) => {
      const date = subMonths(this, i)
      return `${date.getFullYear()}년 ${date.getMonth() + 1}월`
    })
  }

  get pastTwelveMonthStringArr() {
    return Array.from({ length: 12 }, (v, i) => {
      const date = subMonths(this, i)
      return `${date.getFullYear()}년 ${date.getMonth() + 1}월`
    })
  }

  static setPrefixMonth(month: number) {
    return month < 10 ? `0${month}` : `${month}`
  }

  getPastMonthArr(prevLength: number) {
    return Array.from({ length: prevLength + 1 }, (v, i) => {
      return subMonths(this, i)
    })
  }

  getPastYearArr(prevLength: number) {
    return Array.from({ length: prevLength + 1 }, (v, i) => {
      return subYears(this, i)
    })
  }

  getNextYear(date = new Date()) {
    const target = date
    target.setFullYear(target.getFullYear() + 1)
    return target
  }

  getTrueMonth() {
    return this.getMonth() + 1
  }
}

// const d = new ExtendedDate()

// d.minDate = new Date('2020-7-24') /*?*/
// d.maxDate = new Date('2021-1-24') /*?*/
//
// // d.monthArr /*?*/
//
// d.setFullYear(2021)
//
// d.monthArr /*?*/
//
// isAfter(new Date('2020-10-24'), new Date('2020-1-1')) /*?*/

// const myDate = new ExtendedDate('2020.1') /*?*/

// new ExtendedDate().pastTwelveMonthArr /*?*/
// const monthEndDate = dateFns.endOfMonth(new Date()) /*?*/
// const monthStartDate = dateFns.startOfMonth(new Date()) /*?*/
//
// dateFns.getWeekOfMonth(new Date()) /*?*/
//
// dateFns.getDay(new Date()) /*?*/
// dateFns.setISODay(new Date('2020-11-16'), 1) /*?*/
// dateFns.setDay(dateFns.addISOWeekYears(new Date(), 1), 0) /*?*/
// // dateFns.firt /*?*/
// dateFns.startOfMonth(new Date()) /*?*/
// dateFns.startOfISOWeek(new Date('2020-11-01')) /*?*/
// dateFns.endOfISOWeek(new Date('2020-11-30')) /*?*/
//
// dateFns.getISODay(new Date('2020-11-24')) /*?*/
// dateFns.differenceInDays(new Date('2020.09.29'), new Date()) /*?*/
